export default (function () {
  const pathName = window.location.pathname;
  // returns "/www" from for example "/www/default.html"
  const base = pathName.substr(0, pathName.indexOf("/", 1));
  return base;
})();
